const DEFAULT_RENDERER_RESOLUTION = 1
const MAX_RENDERER_RESOLUTION = 2
const MIN_TEXT_RESOLUTION = 2
const MAX_TEXT_RESOLUTION = 4

function positiveFinite(value: number | undefined, fallback: number) {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : fallback
}

export function preferredCanvasRendererResolution(devicePixelRatio: number | undefined) {
  return Math.min(
    MAX_RENDERER_RESOLUTION,
    positiveFinite(devicePixelRatio, DEFAULT_RENDERER_RESOLUTION)
  )
}

export function sharpCanvasTextResolution(
  rendererResolution: number | undefined,
  effectiveDisplayScale: number | undefined
) {
  const baseResolution = positiveFinite(rendererResolution, DEFAULT_RENDERER_RESOLUTION)
  const displayScale = Math.max(
    1,
    positiveFinite(effectiveDisplayScale, DEFAULT_RENDERER_RESOLUTION)
  )

  return Math.min(
    MAX_TEXT_RESOLUTION,
    Math.max(MIN_TEXT_RESOLUTION, Math.ceil(baseResolution * displayScale))
  )
}
